// Auto-generated normalizer for table: CAR_BOOKING.ReservaNotificacion
export function reservaNotificacionNormalize(row) {
  return {
    idNotificacion: row.idNotificacion ?? row.IdNotificacion ?? row['idNotificacion'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    canal: row.canal ?? row.Canal ?? row['canal'] ?? '',
    destinatario: row.destinatario ?? row.Destinatario ?? row['destinatario'] ?? '',
    asunto: row.asunto ?? row.Asunto ?? row['asunto'] ?? '',
    estadoEnvio: row.estadoEnvio ?? row.EstadoEnvio ?? row['estadoEnvio'] ?? '',
    intentos: row.intentos ?? row.Intentos ?? row['intentos'] ?? '',
    fechaEnvio: row.fechaEnvio ?? row.FechaEnvio ?? row['fechaEnvio'] ?? null,
    errorMensaje: row.errorMensaje ?? row.ErrorMensaje ?? row['errorMensaje'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}